
<div class="main-tab-title-box">
  <mat-card-title class="main-title">Tagger</mat-card-title>
  
  <div>
    <analysis-options></analysis-options>
  </div>
</div>
<div *ngIf="loaderActive" class="div_loader_pag">
  <div  id="div_loader_pag">
    <div  class="loader_pag"></div>
  </div>
  <div class="main-box-title-12">Analysis will begin after you finish typing</div>
</div>
<div *ngIf="loaderActive2 && !this.loaderActiveFirstProject" class="div_loader_pag">
  <div  id="div_loader_pag">
    <div  class="loader_pag"></div>
  </div>
  <div class="main-box-title-12">Analysing and Saving</div>
</div>
<div *ngIf="loaderActiveFirstProject" class="div_loader_pag">
  <div  id="div_loader_pag">
    <div  class="loader_pag"></div>
  </div>
  <div class="main-box-title-12">Analysing...</div>
</div>

<mat-card-content>
  <div class="main-box-title-14 space">This tool analyses the basic grammatical parts of speech of your text, based on a modified
    version of the Tree Tagger parser. Click <a href="https://textinspector.com/help/tagger/" class="hiperlinks" target="_blank" rel="noopener noreferrer">HERE</a> for an explanation. If you want to correct a tag, go to Amend Input
    below, change the tag, then click Update.</div>
    
  
    <div class="button-switch-box" [ngClass]="{'checked-style-div-button-switch': !checked}">
      <div (click)="selectMenuItem('pof')" class="button-container left" [ngClass]="{'selected': isSelected('pof'),'checked-style-div-button-container-left': !checked}">
        <div style="margin-top: 8px;">
          <img style="margin-right: 8px; padding-bottom: 2px; vertical-align: middle;" src="./assets/images/extra_tab_icons/parts-of-speech-icon.svg">
          <span class="main-box-title-14" style="padding-top: 2px;">Parts of Speech</span>
          <ng-container *ngIf="!checked"><div class="tooltip-container">
            <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
            <span class="tooltip-text">Lorem ipsum dolor sit amet consetetur sad ipscing elitr sed diam nonumy eirmod temi por invidunt ut labore et dolore magna.</span>
          </div></ng-container>
        </div>
        
      </div>
      <ng-container *ngIf="checked">
        <div class="separator"></div>
        <div (click)="selectMenuItem('summary')" class="button-container right" [ngClass]="{'selected': isSelected('summary')}">
          <div style="margin-top: 9px;">
            <span class="main-box-title-14">Summary</span>
          </div>
        </div>
      </ng-container>
    </div>
  

  <ng-container *ngIf="selectedMenuItem === 'pof'">
    <div id="buttons-box">
      
      <button class="button-seeAll" (click)="toggleSeeAll()" [disabled]="isButtonDisabled()">
        <img class="see-all-icon eye-icon" style="padding-left: 6px;" [src]="seeAllIconSrc" >
        <span class="main-box-title-12">See All</span>
      </button>
      
        <span style="padding-left: 15px;">
          <button class="icon-button">
            <span class="button-block"><div><img src="../assets/images/yellow_icons/blocked-icon.svg" class="export-con"></div><span>Tagger
              Export</span></span>
          </button>
        </span>
        
    </div>
    <div class="content-show-all">
      <button mat-button style="color:#EEA21A;font-size: 14px;" (click)="toggleExpandAll()" [disabled]="isButtonDisabled()">
        {{ showAll ? 'Expand all' : 'Contract all' }}
      </button>
    </div>
    <div class="tagger-list-header">
      <span>Part of Speech</span>
      <span>Tokens/Types</span>
    </div>
    <div class="div_scroll_box">
      <ng-container *ngFor="let data of getObjectKeys(this.pof)">
        <div class="vertical-box">
          <div *ngIf="selectedWord[data]" id="div-category">
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <div style="display: flex;">
                <button class="reset-button" (click)="resetCategoryView(data)">
                  <img src="./assets/images/black_icons/back-Icon.svg">
                </button>
                <div class="main-box-title-16" style="padding-top: 1px;">Change Tag</div>
              </div>
              <button class="main-box-title-14 update-button" (click)="updateCategory(data)">Update</button>
            </div>
            <ng-container *ngFor="let index of [].constructor(encontrarCantidad(selectedWord[data],data.toUpperCase() )); let i = index">
              <div class="horizontal-box" style="border: none; margin-bottom: 0px;">
                <div class="main-box-title-12"><img class="eye-icon"
                  [src]="palabraSeleccionada[data.toUpperCase() + '-' + selectedWord[data] + '-' + i] 
                         ? '../../assets/images/yellow_icons/eye-on-icon.svg' 
                         : '../../assets/images/eye-icon.svg'"(click)="verPalabra(selectedWord[data], data, i,true)"><strong>Word:</strong> {{selectedWord[data]}}</div>
                <div class="main-box-title-12"><strong>Part of speech:</strong> {{ data.toUpperCase() }} ({{this.pof[data].description | titlecase}})</div>
              </div>
              <div *ngIf="respuestaWords" class="main-box-title-12" style="display: grid;grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));gap: 10px; margin-left: 10px; margin-top: 10px;">
                  <div *ngFor="let item of respuestaWords" style="display: flex; align-items: flex-start;">
                      <input type="radio" 
                        name="palabra-{{i}}" 
                        [value]="item.value" 
                        [checked]="isWordSelected(item.value, data, item)"
                        (change)="onSelectionRadioChange(selectedWord[data], i, data, item.value, item.descripcion); verPalabra(selectedWord[data], data, i,false)" 
                        />
                        <!-- [checked]="isWordSelected(data, i, item)" -->
                      <td class="custom-cell description-cell" style="text-align: left;">{{item.value}} ({{ item.descripcion }})</td>
                  </div>
              </div>
            </ng-container>

          </div>
        <div *ngIf="!selectedWord[data]">
          <div  class="horizontal-box" style="border: none; margin-bottom: 0px; cursor: pointer;" (click)="toggleExpand(data)" [ngClass]="{'expanded': isExpanded[data]}">
            <div class="main-box-title-14">
              <div style="display: flex;">
                <img class="eye-icon" [src]="isEyeOn[data.toUpperCase()] ? './assets/images/yellow_icons/eye-on-icon.svg' : './assets/images/eye-icon.svg'"
                (click)="toggleEyeIcon(data); $event.stopPropagation()">
                <div style="margin-top: 1px;">
                  {{data | uppercase}} ({{this.pof[data].description | titlecase}})
                </div>
                <ng-container *ngIf="!checked">
                  <div class="tooltip-container">
                    <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                    <span class="tooltip-text">Lorem ipsum dolor sit amet consetetur sad ipscing elitr sed diam nonumy eirmod temi por invidunt ut labore et dolore magna.</span>
                  </div>
                </ng-container>
              </div>
            
            </div>
            <div style="display: flex;">
              <div class="main-box-value-16-bold" style="margin-top: 1px;">{{this.pof[data].tokens}} / {{this.pof[data].uniqueTokens}}</div>
              <mat-icon class="expand-icon">expand_more</mat-icon>
            </div>
          </div>
        
            
            <div class="words-content" *ngIf="isExpanded[data]">
              <ng-container *ngFor="let item of getObjectKeys(data_pof[data.toUpperCase()])">
                <div class="item-listado-errores">
                  <span (mouseenter)="ponerOjo($event, data, item)" (mouseleave)="quitarOjo($event, data, item)" style="display:flex; padding: 4px;" *ngIf="isScreenLarge; else mobileLayout">
                    <ng-container >
                      <img src="./assets/images/eye-icon.svg" class="icon-eye" *ngIf="!palabraresaltada[data.toUpperCase()]?.[item]" (click)="toggleEyeIconPalabra(data, item)" style="margin-right: 5px;">
                      <img src="./assets/images/yellow_icons/eye-on-icon.svg" class="icon-eye" *ngIf="palabraresaltada[data.toUpperCase()]?.[item]" (click)="toggleEyeIconPalabra(data, item)" style="margin-right: 5px;">
                      <img *ngIf="checked" src="./assets/images/project-icon.svg" style="margin-right: 5px;" (click)="selectWord(data, item)" class="icon-project">
                      <div>
                        {{item}} / {{data_pof[data.toUpperCase()][item]}}
                      </div>
                    </ng-container>
                    
                  </span>
                  <span style="display:flex; padding: 4px;">
                  <ng-template #mobileLayout>
                    <img src="./assets/images/eye-icon.svg" class="icon-eye" *ngIf="!palabraresaltada[data.toUpperCase()]?.[item]" (touchstart)="toggleEyeIconPalabra(data, item)" style="margin-right: 5px;">
                    <img src="./assets/images/yellow_icons/eye-on-icon.svg" class="icon-eye" *ngIf="palabraresaltada[data.toUpperCase()]?.[item]" (touchstart)="toggleEyeIconPalabra(data, item)" style="margin-right: 5px;">
                    <img *ngIf="checked" src="./assets/images/project-icon.svg" style="margin-right: 5px;" (click)="selectWord(data, item)" class="icon-project">
                    <div>
                      {{item}} / {{data_pof[data.toUpperCase()][item]}}
                    </div>
                  </ng-template>
                  </span>
                </div>
              </ng-container>
            

              <!-- <div class="item-listado-errores" *ngFor="let item of data_pof[data.toUpperCase()]">{{item}}</div> -->
            </div>
          </div>
        </div>
      </ng-container>
    </div>

  </ng-container>

  <ng-container *ngIf="selectedMenuItem === 'summary'">
    <div class="horizontal-box">
      <div class="main-box-title-14 tem-padd-left" >Coverage</div>
      <div class="main-box-value-16-bold tem-padd-right" >{{summary.coverage.total ? summary.coverage.total:"--"}}% ({{summary.coverage.counted}} counted / {{summary.coverage.not_counted}} not counted)</div>
    </div>
    <div class="horizontal-box">
      <div class="main-box-title-14 tem-padd-left" >Tokens (total items)</div>
      <div class="main-box-value-16-bold tem-padd-right" >{{summary.tokens ? summary.tokens:"--"}}</div>
    </div>
    <div class="horizontal-box">
      <div class="main-box-title-14 tem-padd-left" >Types (unique items)</div>
      <div class="main-box-value-16-bold tem-padd-right" >{{summary.types ? summary.types:"--"}}</div>
    </div>
    <div class="horizontal-box">
      <div class="main-box-title-14 tem-padd-left" >Elements (includes homonyms)</div>
      <div class="main-box-value-16-bold tem-padd-right" >{{summary.elements ? summary.elements:"--"}}</div>
    </div>
    <div class="horizontal-box">
      <div class="main-box-title-14 tem-padd-left" >Type/token ratio</div>
      <div class="main-box-value-16-bold tem-padd-right" >{{summary.type_token ? summary.type_token:"--"}}</div>
    </div>
    <div class="horizontal-box">
      <div class="main-box-title-14 tem-padd-left" >Tokens per type</div>
      <div class="main-box-value-16-bold tem-padd-right" >{{summary.tokens_per_type ? summary.tokens_per_type:"--"}}</div>
    </div>
    <div class="horizontal-box">
      <div class="main-box-title-14 tem-padd-left" >Total Verbal Elements</div>
      <div class="main-box-value-16-bold tem-padd-right" >{{summary.total_verbal ? summary.total_verbal:"--"}}</div>
    </div>
    <div class="horizontal-box">
      <div class="main-box-title-14 tem-padd-left" >Verbal Elements per Sentence</div>
      <div class="main-box-value-16-bold tem-padd-right" >{{summary.verbal_elements ? summary.verbal_elements:"--"}}</div>
    </div>
    <div class="horizontal-box">
      <div class="main-box-title-14 tem-padd-left" >Total Noun Elements</div>
      <div class="main-box-value-16-bold tem-padd-right" >{{summary.total_noun ? summary.total_noun:"--"}}</div>
    </div>
    <div class="horizontal-box">
      <div class="main-box-title-14 tem-padd-left" >Noun Elements per Sentence</div>
      <div class="main-box-value-16-bold tem-padd-right" >{{summary.noun_elements ? summary.noun_elements:"--"}}</div>
    </div>
  </ng-container>

  <ng-container *ngIf="!checked">
    <div class="text-box-bottom-simple-mode">
      <div class="line-box-bottom-simple-mode">
        <div class="bottom-text-line-simple-mode"></div>
      </div>
      <span class="main-box-title-14 tem-padd-left">To see full statistics, switch to “Advanced Mode”.</span>
    </div>
  </ng-container>
  

</mat-card-content>
